import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@infra-adapters/services/auth.service';
import { PermissionsService } from '@infra-adapters/services/permissions.service';

let isRefreshing = false;

export const authErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.headers.has('Authorization')) {
        return throwError(() => error);
      }
      if (error.status === 401 && !isRefreshing) {
        const refreshToken = authService.getRefreshToken();
        if (refreshToken) {
          isRefreshing = true;
          return authService.refreshTokens(refreshToken).pipe(
            switchMap((response) => {
              isRefreshing = false;
              const { token, refresh_token } = response.data;
              authService.setSession(token, refresh_token);
              const clonedReq = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
              });
              return next(clonedReq);
            }),
            catchError((refreshError) => {
              isRefreshing = false;
              const currentUrl = router.url;
              authService.cleanSession();
              permissionsService.clear();
              router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
              return throwError(() => refreshError);
            })
          );
        }

        const currentUrl = router.url;
        authService.cleanSession();
        permissionsService.clear();
        router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
      }
      return throwError(() => error);
    })
  );
};
